import React from 'react';
import StripedDataGrid from '../../../shared/StripedDataGrid';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment-timezone';
import { ListBooking } from '../../../types/reservation';

interface FailedTableProps {
    data: ListBooking[];
}

const FailedTable = ({ data }: FailedTableProps) => {
    const columns: GridColDef[] = [
        {
            field: 'module.name',
            headerName: 'Experience',
            flex: 1,
            type: 'string',
            sortable: true,
            valueGetter: (params) => {
                return params?.value ? params?.value : params?.row?.module.name;
            },
        },
        {
            headerName: 'Ref',
            field: 'id',
            flex: 1,
            type: 'string',
            sortable: true,
            renderCell: (params) => `#${params.value}`,
        },
        {
            headerName: 'Check-in',
            field: 'startDate',
            flex: 1,
            type: 'string',
            sortable: true,
            renderCell: (params) => moment(params?.value).format('ll'),
        },

        {
            headerName: 'Checkout',
            field: 'endDate',
            flex: 1,
            type: 'string',
            sortable: true,
            renderCell: (params) => moment(params?.value).format('ll'),
        },
    ];

    return (
        <StripedDataGrid
            rows={data}
            columns={columns}
            onRowClick={(params) =>
                window.open(`/reservations/experience/${params.id}`, '_blank')
            }
        />
    );
};

export default FailedTable;
